const { createSlice } = require('@reduxjs/toolkit');

const currencySlice = createSlice({
    name: "currency",
    initialState: {
        currencySymbol: "Rp",
        currencyName: "IDR",
        currencyRate: 1
    },
    reducers: {
        setCurrency(state, action) {
            const currencyName = action.payload;

            if (currencyName === "USD") {
                state.currencySymbol = "$";
                state.currencyRate = 1; // or whatever the USD rate is
                state.currencyName = "USD";
            } else {
                // Default to IDR
                state.currencySymbol = "Rp";
                state.currencyRate = 1;
                state.currencyName = "IDR";
            }
        }
    },
});

export const { setCurrency } = currencySlice.actions;
export default currencySlice.reducer;
